import { render } from "./popBg.vue?vue&type=template&id=7b98fd30&scoped=true"
import script from "./popBg.vue?vue&type=script&lang=js"
export * from "./popBg.vue?vue&type=script&lang=js"

import "./popBg.vue?vue&type=style&index=0&id=7b98fd30&lang=scss&scoped=true"

import exportComponent from "/Users/liuli/Desktop/istory/vue3-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b98fd30"]])

export default __exports__